import React from 'react'
import Provider from './Provider'
import { DidYouKnow, Section, AsyncResponsesLoading } from 'components'
import { Grid, Box } from '@material-ui/core'
import useStyles from './Styles'
import { Corner } from 'components/balloon'
import { ComplexDidYouKnowComponent } from '../complexDidYouKnowComponent'
import { IDidYouKnowLinkerProps, IDidYouKnowViewProps } from './Interface'

const DidYouKnowPage: React.FC<IDidYouKnowViewProps> = React.memo(
  ({ onQuestionsAnswerChanged, responses, validations, disabled, embeddedPage }) => {
    const classes = useStyles({})

    const sanitizeStatDetail = (currentValue: string, newValue: string) => {
      const reg = new RegExp('^\\d+$')

      if (!newValue || !newValue.trim().length) {
        return ''
      }
      return reg.test(newValue) ? newValue : currentValue
    }

    let statsError = null

    if (!validations.statNum?.valid && validations.statNum?.stack) {
      statsError = validations.statNum.stack
    } else if (!validations.statDetail?.valid && validations.statDetail?.stack) {
      statsError = validations.statDetail.stack
    }

    const content = (
      <Grid container spacing={2} className={classes.didYouKnow} wrap={'wrap'}>
        <Grid item md={4} sm={6} xs={12}>
          <DidYouKnow
            disabled={disabled}
            questionKey={'funFact'}
            bgColor={'#314DA1'}
            title={'Fun fact about me'}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'funFact')}
            answer={responses.funFact}
            error={validations.funFact?.stack}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <ComplexDidYouKnowComponent
            disabled={disabled}
            questionKey={'statNum'}
            showInputTitle={true}
            title={'A personal statistic'}
            answerTitlePlaceholder="Enter number"
            answerTitle={responses.statNum || ''}
            answer={responses.statDetail}
            corner={Corner.TopLeft}
            bgColor={'#F26723'}
            sanitizeTitle={sanitizeStatDetail}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'statDetail')}
            handleConfirmTitle={onQuestionsAnswerChanged.bind(null, 'statNum')}
            error={statsError}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <DidYouKnow
            disabled={disabled}
            questionKey={'randomJob'}
            title={'A random job I’d be really good at'}
            corner={Corner.TopRight}
            bgColor={'#2166A4'}
            answer={responses.randomJob}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'randomJob')}
            error={validations.randomJob?.stack}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <DidYouKnow
            disabled={disabled}
            questionKey={'uniqueInterest'}
            title={'Unique interests'}
            corner={Corner.BottomRight}
            bgColor={'#413292'}
            answer={responses.uniqueInterest}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'uniqueInterest')}
            error={validations.uniqueInterest?.stack}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <DidYouKnow
            disabled={disabled}
            questionKey={'tedTalk'}
            title={'One day I’ll do a Ted Talk on'}
            corner={Corner.BottomLeft}
            bgColor={'#64CCE9'}
            answer={responses.tedTalk}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'tedTalk')}
            error={validations.tedTalk?.stack}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <DidYouKnow
            disabled={disabled}
            questionKey={'projectTolife'}
            title={'If I could bring a project to life, it would be'}
            corner={Corner.TopLeft}
            bgColor={'#FDB72A'}
            answer={responses.projectToLife}
            handleConfirm={onQuestionsAnswerChanged.bind(null, 'projectToLife')}
            error={validations.projectToLife?.stack}
          />
        </Grid>
      </Grid>
    )

    return (
      <Grid container direction={'column'}>
        {embeddedPage ? (
          content
        ) : (
          <Section padding={'60px 10px 10px 50px'} direction={'column'}>
            {content}
            <Box mt={8} />
          </Section>
        )}
      </Grid>
    )
  }
)

DidYouKnowPage.defaultProps = {
  embeddedPage: false
}

export default (props: IDidYouKnowLinkerProps) => (
  <AsyncResponsesLoading>
    <Provider {...props}>{(viewProps: IDidYouKnowViewProps) => <DidYouKnowPage {...viewProps} />}</Provider>
  </AsyncResponsesLoading>
)
